import ProBadge from "../assets/images/pro-badge.png";
import PlusBadge from "../assets/images/upgrade-plus-and-pro/plus-badge.png";
import scorzaWordmark from "../assets/images/scorza-wordmark-white.svg";
import { FC } from "react";
import "./ProductBadge.css";

export type ProductBadgeProps = {
    type: "pro" | "basic";
    width?: string;
    height?: string;
};
export const ProductBadge: FC<ProductBadgeProps> = ({
    type,
    height = "50px",
}) => {
    return (
        <div className={`product-badge`}>
            <img src={scorzaWordmark} alt="Scorza" height={height} />
            <img
                src={type === "pro" ? ProBadge : PlusBadge}
                height={height}
                alt={type}
            />
        </div>
    );
};
